<template>
    <nav class="navbar navbar-expand-sm fixed-top navbar-dark justify-content-between py-0">
        <div class="row w-100 mx-0">
            <div class="text-left col-6 col-sm-4">
                <vue-menu-overlay :menus="links" :label="label" :currentpath="currentpath" icon="fa fa-navicon pr-3" className="navbar-brand"></vue-menu-overlay>
            </div>
            <div class="d-flex align-items-center logo col-6 col-sm-4 justify-content-end justify-content-sm-center">
                <w-icon name="logo" height="65%" class="astra-logo-svg"/>
            </div>
        </div>
    </nav>

</template>

<script>

import HeaderStyle from '../style/header'
import VueMenuOverlay from '../components/Global/MenuOverlay'
import { storeLink } from '../app-config'
import { mapGetters } from 'vuex'

export default {
    name: 'Header',
    props: ['label', 'currentpath'],
    data () {
        return {
            navStyle: HeaderStyle.nav,
            links: [
                {
                    title: 'My Pools',
                    name: 'home',
                    path: 'mypools',
                    target: '',
                    image: 'my-pools.png',
                    public: true,
                    active_image: 'my-pools-active.png'
                },
                {
                    title: 'My Profile',
                    name: 'Profile',
                    path: 'profile',
                    target: '',
                    image: 'profile.png',
                    public: false,
                    active_image: 'profile-active.png'
                },
                {
                    title: 'Store',
                    url: storeLink,
                    path: '',
                    target: '',
                    image: 'store.png',
                    public: true,
                    active_image: 'store-active.png'
                },
                {
                    title: 'Help',
                    name: 'HelpVideos',
                    path: 'help',
                    target: '',
                    image: 'support.png',
                    public: true,
                    active_image: 'support-active.png'
                },
                {
                    title: 'Logout',
                    name: 'auth_SignOut',
                    path: 'auth/signOut',
                    target: '',
                    image: 'log-out.png',
                    public: false,
                    active_image: 'log-out-active.png'
                },
                {
                    title: 'Login',
                    name: 'auth_SignIn',
                    path: 'auth/signIn',
                    target: '',
                    image: 'log-out.png',
                    public: true,
                    active_image: 'log-out-active.png'
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            userId: 'auth/userId'
        })
    },
    components: {
        VueMenuOverlay
    },
    methods: {
        home: function () {
            this.$router.push('/').catch(err => err)
        },
        signOut: function () {
            this.$router.push('/auth/signOut')
        }
    }
}
</script>

<style scoped>
    .logo {
        height: 85px;
    }

    .col-sm-4 {
        line-height: 75px;
    }

    @media (max-width: 576px) {
        .col-sm-4 {
            line-height: 60px;
            text-align: right;
        }
    }
</style>
